export type FlooriRoutes =
    | 'ar'
    | 'calculator'
    | 'room'
    | 'rooms'
    | 'preview'
    | 'notFound'
    | 'login';

export const flooriRoutes: Record<FlooriRoutes, string> = {
    ar: 'ar',
    calculator: 'calculator',
    rooms: '',
    room: 'room/:uid',
    preview: 'preview',
    notFound: 'not-found',
    login: 'login',
} as const;
